import { useEffect, useState } from "react";
import { resolveActionsCatalogue } from "../helpers/correctiveActions";

/**
 * Resuelve, para un tipo de accion (medida | sancion), de que catalogo debe
 * leer la pantalla. Lo comparten la conclusion de la investigacion y el flujo
 * de atencion para que ambas siempre ofrezcan exactamente la misma lista.
 *
 * `catalogue` en null significa que el tenant no tiene catalogo configurado y
 * el formulario debe usar sus opciones hardcodeadas de respaldo.
 */
export const useActionsCatalogue = (type) => {
  const [source, setSource] = useState({
    catalogue: null,
    isOwn: false,
    rootPath: "/",
    isUnified: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    if (!type) {
      setIsLoading(false);
      return undefined;
    }
    setIsLoading(true);
    resolveActionsCatalogue(type)
      .then((resolved) => {
        if (!mounted) return;
        setSource(
          resolved || {
            catalogue: null,
            isOwn: false,
            rootPath: "/",
            isUnified: false,
          }
        );
      })
      .finally(() => {
        if (mounted) setIsLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [type]);

  return { ...source, isLoading };
};
